import { apiWithoutBaseURL } from './api'
import config from '@/config'

class FileService {
    // 添加文件夹
    static async addFolder(data) {
        const response = await apiWithoutBaseURL.post('/FileManage/api/addFolder/', data)
        return response.data
    }

    // 重命名文件/文件夹
    static async renameFile(data) {
        const response = await apiWithoutBaseURL.post('/FileManage/api/renameFile/', data)
        return response.data
    }

    // 删除文件/文件夹
    static async deleteFile(data) {
        const response = await apiWithoutBaseURL.post('/FileManage/api/deleteFile/', data)
        return response.data
    }

    // 更新文件内容
    static async updateFile(data) {
        const response = await apiWithoutBaseURL.post('/FileManage/api/updateFile/', data)
        return response.data
    }

    // 获取文件类型
    static async getFileType(fileName) {
        const response = await apiWithoutBaseURL.get(`/FileManage/api/getFileType/${fileName}`)
        return response.data
    }

    // 获取目录树结构
    static async getDirectoryTree() {
        const response = await apiWithoutBaseURL.get('/FileManage/api/getDirectoryTree/')
        return response.data
    }

    // 上传文件
    static async uploadFile(formData) {
        // 上传文件需要使用完整的API基础URL，不能使用带/api前缀的axios实例
        // 因为文件上传需要绕过代理配置的/api前缀
        const response = await apiWithoutBaseURL.post(
            `${config.API_BASE_URL}/FileManage/api/uploadFile/`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
        return response.data
    }
}

export default FileService